import { ArrowRight, Mail } from "lucide-react";
import { Reveal } from "../lib/motion";

export const FinalCTA = ({ onConsult }) => (
  <section id="consult" data-testid="final-cta-section" className="relative overflow-hidden bg-navy py-24 md:py-32">
    <div aria-hidden="true" className="absolute inset-0 dark-grid-bg" />
    <div
      aria-hidden="true"
      className="pointer-events-none absolute left-1/2 top-1/2 h-[420px] w-[720px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[radial-gradient(circle,rgba(245,166,35,0.16),transparent_65%)]"
    />
    <div className="relative max-w-3xl mx-auto px-6 text-center">
      <Reveal>
        <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-white leading-[1.08]">
          Ready to strengthen your <span className="text-brand">finance function?</span>
        </h2>
      </Reveal>
      <Reveal delay={0.12}>
        <p className="mt-6 text-base md:text-lg leading-relaxed text-white/65">
          Whether you need Fractional CFO leadership, Finance Shared Services,
          custom AI tools for finance operations, stronger financial controls,
          an India finance partner or a Finance Transformation programme —
          start with a conversation about your priorities.
        </p>
      </Reveal>
      <Reveal delay={0.22}>
        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            data-testid="final-book-consultation-btn"
            onClick={onConsult}
            className="group inline-flex items-center gap-2 rounded-full bg-brand px-9 py-4 text-sm font-bold text-navy shadow-[0_12px_36px_rgba(245,166,35,0.4)] transition-[transform,background-color,color] duration-300 hover:bg-brand-hover hover:text-white hover:scale-[1.04] active:scale-[0.98]"
          >
            Book a Consultation
            <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
          </button>
          <a
            data-testid="final-email-link"
            href="mailto:ramesh@cogniticfo.com"
            className="inline-flex items-center gap-2 rounded-full border border-white/20 px-8 py-4 text-sm font-bold text-white transition-[border-color,background-color] duration-300 hover:border-white/50 hover:bg-white/5"
          >
            <Mail size={15} />
            Email Us
          </a>
        </div>
        <p className="mt-7 text-sm text-white/50">
          Start with a 30-minute conversation about your finance priorities.
        </p>
      </Reveal>
    </div>
  </section>
);
